import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingProducts } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormProducts = () => {

    const { t } = useTranslation('booking');

    const productsQuery = useQuery({
        queryKey: [ReactQueryKey.BookingProducts, {}],
        queryFn: () => getBookingProducts(),
        enabled: false
    });

    const handleOnOpen = () => {
        if(productsQuery.data == undefined) 
            productsQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="products"
            label={t('label.products')}
            options={productsQuery.data || []}
            loading={productsQuery.isLoading}
            multiple
            isOptionEqualToValue={(option, value) => option.code === value.code}
            getOptionLabel={(option) => (option.code + ' - ' + option.label)} 
            onOpen={handleOnOpen}
        />
    );
};

export default FormProducts;
